const options = [
  {
    value: "PASTOR",
  },
  {
    value: "DEACON",
  },
  {
    value: "DEACONESS",
  },
  {
    value: "BROTHER",
  },
  {
    value: "SISTER",
  },
];

const genders = [
  {
    value: "MALE",
  },
  {
    value: "FEMALE",
  },
];

const Campuses = [
  { value: "BLW ZONE A" },
  { value: "BLW ZONE B" },
  { value: "BLW ZONE C" },
  { value: "BLW ZONE D" },
  { value: "BLW ZONE E" },
  { value: "BLW ZONE F" },
  { value: "BLW ZONE G" },
  { value: "BLW ZONE H" },
  { value: "BLW ZONE I" },
  { value: "BLW ZONE J" },
  { value: "BLW ZONE K" },
  { value: "BLW ZONE L" },
  { value: "BLW UK ZONE A" },
  { value: "BLW UK ZONE B" },
  { value: "BLW GHANA ZONE A" },
  { value: "BLW GHANA ZONE B" },
  { value: "BLW KENYA ZONE" },
  { value: "BLW SA ZONE A" },
  { value: "BLW SA ZONE B" },
  { value: "BLW SA ZONE C" },
  { value: "BLW SA ZONE D" },
  { value: "BLW SA ZONE E" },
  { value: "BLW CAMEROON GRP 1" },
  { value: "BLW CAMEROON GRP 2" },
  { value: "BLW CAMEROON GRP 3" },
  { value: "BLW USA GRP 1" },
  { value: "BLW USA GRP 2" },
  { value: "BLW USA GRP 3" },
  { value: "BLW USA GRP 4" },
  { value: "BLW CANADA GRP" },
  { value: "BLW UGANDA GRP" },
  { value: "BLW INTERNATIONAL MISSIONS" },
];

const Zones = [
  { value: " CE Lagos Zone 1" },
  { value: " CE Lagos Zone 2" },
  { value: " CE Lagos Zone 3" },
  { value: " CE Lagos Zone 4" },
  { value: " CE Lagos Zone 5" },
  { value: " CHRIST EMBASSY LAGOS VIRTUAL ZONE" },
  { value: " CE USA  Region 1 Zone 1" },
  { value: " CE USA  Region 1 Zone 2" },
  { value: " CE USA  Region 2 Zone 1" },
  { value: " CE USA  Region 2 Zone 2" },
  { value: " Texas Zone 1" },
  { value: " Texas Zone 2" },
  { value: " CE UK Region - Zone 1" },
  { value: " CE UK Region - Zone 2" },
  { value: " CE UK Region - Zone 3" },
  { value: " CE UK Region - Zone 4" },
  { value: " CE SA Zone 1" },
  { value: " CE SA Zone 2" },
  { value: " CE SA Zone 3" },
  { value: " CE SA Zone 4" },
  { value: " CE SA Zone 5" },
  { value: " CE Accra Ghana Zone" },
  { value: " CE Onitsha Zone" },
  { value: " CE PH Zone 1" },
  { value: " CE PH Zone 2" },
  { value: " CE PH Zone 3" },
  { value: " CE Abuja Zone" },
  { value: " CE Benin Zone 1" },
  { value: " CE Mid-West Zone" },
  { value: " Kenya Zone" },
  { value: " CE UK Region 2 - Zone 1" },
  { value: " CE UK Region 2 - Zone 3" },
  { value: " CE UK Region 2 - Zone 4" },
  { value: " Western Europe Zone 1" },
  { value: " Western Europe Zone 2" },
  { value: " Western Europe Zone 3" },
  { value: " Western Europe Zone 4" },
  { value: " CE Quebec Zone" },
  { value: " CE EWCA Zone 2" },
  { value: " CE EWCA Zone 3" },
  { value: " CE EWCA Zone 4" },
  { value: " CE EWCA Zone 5" },
  { value: " CE EWCA Zone 6" },
  { value: " CE North West Zone 1" },
  { value: " CE North West Zone 2" },
  { value: " CE North Central Zone 1" },
  { value: " CE North Central Zone 2" },
  { value: " CE North East Zone 1" },
  { value: " South East Zone 1" },
  { value: " South East Zone 2" },
  { value: " CE South South Zone 1" },
  { value: " CE South South Zone 2" },
  { value: " South West Zone 1" },
  { value: " South West Zone 2" },
  { value: " South West Zone 3" },
  { value: " CE Aba Zone" },
  { value: " Edo North &amp; Edo Central Zone" },
  { value: " CE Benin Zone" },
  { value: " Ministry Center Abuja" },
  { value: " Ministry Centre Port Harcourt" },
  { value: " Ministry Centre Warri" },
  { value: " Ministry Centre Abeokuta" },
  { value: " Ministry Center Calabar" },
  { value: " CE Canada Zone" },
  { value: " Corpers' Loveworld" },
  { value: " Others" },
  { value: " CE UK Region 2 - Zone 2" },
  { value: " CE EWCA Zone 1" },
  { value: " Middle East &amp; South East Asia" },
  { value: " Eastern Europe Region" },
  { value: " CE Lagos Zone 6" },
  { value: " CE Lagos Sub Zone A" },
  { value: " CE Lagos Sub Zone B" },
  { value: " CE Lagos Sub Zone C" },
  { value: " CE Uyo zone" },
  { value: " Warri  subzone" },
  { value: " South East Zone 3" },
  { value: " Ibadan Zone" },
  { value: " Loveworld UK Zone 4" },
  { value: " Toronto Zone" },
  { value: " BLW Zone A" },
  { value: " BLW Woji" },
  { value: " BLW Zone H" },
  { value: " CE Chad" },
  { value: " Ottawa Zone" },
  { value: " South Pacific" },
];

const Countries = [
  { value: "Afghanistan" },
  { value: "Aland Islands" },
  { value: "Albania" },
  { value: "Algeria" },
  { value: "American Samoa" },
  { value: "Andorra" },
  { value: "Angola" },
  { value: "Anguilla" },
  { value: "Antarctica" },
  { value: "Antigua And Barbuda" },
  { value: "Argentina" },
  { value: "Armenia" },
  { value: "Aruba" },
  { value: "Australia" },
  { value: "Austria" },
  { value: "Azerbaijan" },
  { value: "Bahamas The" },
  { value: "Bahrain" },
  { value: "Bangladesh" },
  { value: "Barbados" },
  { value: "Belarus" },
  { value: "Belgium" },
  { value: "Belize" },
  { value: "Benin" },
  { value: "Bermuda" },
  { value: "Bhutan" },
  { value: "Bolivia" },
  { value: "Bosnia and Herzegovina" },
  { value: "Botswana" },
  { value: "Bouvet Island" },
  { value: "Brazil" },
  { value: "British Indian Ocean Territory" },
  { value: "Brunei" },
  { value: "Bulgaria" },
  { value: "Burkina Faso" },
  { value: "Burundi" },
  { value: "Cambodia" },
  { value: "Cameroon" },
  { value: "Canada" },
  { value: "Cape Verde" },
  { value: "Cayman Islands" },
  { value: "Central African Republic" },
  { value: "Chad" },
  { value: "Chile" },
  { value: "China" },
  { value: "Christmas Island" },
  { value: "Cocos (Keeling) Islands" },
  { value: "Colombia" },
  { value: "Comoros" },
  { value: "Congo" },
  { value: "Congo The Democratic Republic Of The" },
  { value: "Cook Islands" },
  { value: "Costa Rica" },
  { value: "Cote D'Ivoire (Ivory Coast)" },
  { value: "Croatia (Hrvatska)" },
  { value: "Cuba" },
  { value: "Cyprus" },
  { value: "Czech Republic" },
  { value: "Denmark" },
  { value: "Djibouti" },
  { value: "Dominica" },
  { value: "Dominican Republic" },
  { value: "East Timor" },
  { value: "Ecuador" },
  { value: "Egypt" },
  { value: "El Salvador" },
  { value: "Equatorial Guinea" },
  { value: "Eritrea" },
  { value: "Estonia" },
  { value: "Ethiopia" },
  { value: "Falkland Islands" },
  { value: "Faroe Islands" },
  { value: "Fiji Islands" },
  { value: "Finland" },
  { value: "France" },
  { value: "French Guiana" },
  { value: "French Polynesia" },
  { value: "French Southern Territories" },
  { value: "Gabon" },
  { value: "Gambia The" },
  { value: "Georgia" },
  { value: "Germany" },
  { value: "Ghana" },
  { value: "Gibraltar" },
  { value: "Greece" },
  { value: "Greenland" },
  { value: "Grenada" },
  { value: "Guadeloupe" },
  { value: "Guam" },
  { value: "Guatemala" },
  { value: "Guernsey and Alderney" },
  { value: "Guinea" },
  { value: "Guinea-Bissau" },
  { value: "Guyana" },
  { value: "Haiti" },
  { value: "Heard and McDonald Islands" },
  { value: "Honduras" },
  { value: "Hong Kong S.A.R." },
  { value: "Hungary" },
  { value: "Iceland" },
  { value: "India" },
  { value: "Indonesia" },
  { value: "Iran" },
  { value: "Iraq" },
  { value: "Ireland" },
  { value: "Israel" },
  { value: "Italy" },
  { value: "Jamaica" },
  { value: "Japan" },
  { value: "Jersey" },
  { value: "Jordan" },
  { value: "Kazakhstan" },
  { value: "Kenya" },
  { value: "Kiribati" },
  { value: "Korea North" },
  { value: "Korea South" },
  { value: "Kuwait" },
  { value: "Kyrgyzstan" },
  { value: "Laos" },
  { value: "Latvia" },
  { value: "Lebanon" },
  { value: "Lesotho" },
  { value: "Liberia" },
  { value: "Libya" },
  { value: "Liechtenstein" },
  { value: "Lithuania" },
  { value: "Luxembourg" },
  { value: "Macau S.A.R." },
  { value: "Macedonia" },
  { value: "Madagascar" },
  { value: "Malawi" },
  { value: "Malaysia" },
  { value: "Maldives" },
  { value: "Mali" },
  { value: "Malta" },
  { value: "Man (Isle of)" },
  { value: "Marshall Islands" },
  { value: "Martinique" },
  { value: "Mauritania" },
  { value: "Mauritius" },
  { value: "Mayotte" },
  { value: "Mexico" },
  { value: "Micronesia" },
  { value: "Moldova" },
  { value: "Monaco" },
  { value: "Mongolia" },
  { value: "Montenegro" },
  { value: "Montserrat" },
  { value: "Morocco" },
  { value: "Mozambique" },
  { value: "Myanmar" },
  { value: "Namibia" },
  { value: "Nauru" },
  { value: "Nepal" },
  { value: "Netherlands Antilles" },
  { value: "Netherlands The" },
  { value: "New Caledonia" },
  { value: "New Zealand" },
  { value: "Nicaragua" },
  { value: "Niger" },
  { value: "Nigeria" },
  { value: "Niue" },
  { value: "Norfolk Island" },
  { value: "Northern Mariana Islands" },
  { value: "Norway" },
  { value: "Oman" },
  { value: "Pakistan" },
  { value: "Palau" },
  { value: "Palestinian Territory Occupied" },
  { value: "Panama" },
  { value: "Papua new Guinea" },
  { value: "Paraguay" },
  { value: "Peru" },
  { value: "Philippines" },
  { value: "Pitcairn Island" },
  { value: "Poland" },
  { value: "Portugal" },
  { value: "Puerto Rico" },
  { value: "Qatar" },
  { value: "Reunion" },
  { value: "Romania" },
  { value: "Russia" },
  { value: "Rwanda" },
  { value: "Saint Helena" },
  { value: "Saint Kitts And Nevis" },
  { value: "Saint Lucia" },
  { value: "Saint Pierre and Miquelon" },
  { value: "Saint Vincent And The Grenadines" },
  { value: "Saint-Barthelemy" },
  { value: "Saint-Martin (French part)" },
  { value: "Samoa" },
  { value: "San Marino" },
  { value: "Sao Tome and Principe" },
  { value: "Saudi Arabia" },
  { value: "Senegal" },
  { value: "Serbia" },
  { value: "Seychelles" },
  { value: "Sierra Leone" },
  { value: "Singapore" },
  { value: "Slovakia" },
  { value: "Slovenia" },
  { value: "Solomon Islands" },
  { value: "Somalia" },
  { value: "South Africa" },
  { value: "South Georgia" },
  { value: "South Sudan" },
  { value: "Spain" },
  { value: "Sri Lanka" },
  { value: "Sudan" },
  { value: "Suriname" },
  { value: "Svalbard And Jan Mayen Islands" },
  { value: "Swaziland" },
  { value: "Sweden" },
  { value: "Switzerland" },
  { value: "Syria" },
  { value: "Taiwan" },
  { value: "Tajikistan" },
  { value: "Tanzania" },
  { value: "Thailand" },
  { value: "Togo" },
  { value: "Tokelau" },
  { value: "Tonga" },
  { value: "Trinidad And Tobago" },
  { value: "Tunisia" },
  { value: "Turkey" },
  { value: "Turkmenistan" },
  { value: "Turks And Caicos Islands" },
  { value: "Tuvalu" },
  { value: "Uganda" },
  { value: "Ukraine" },
  { value: "United Arab Emirates" },
  { value: "United Kingdom" },
  { value: "United States" },
  { value: "United States Minor Outlying Islands" },
  { value: "Uruguay" },
  { value: "Uzbekistan" },
  { value: "Vanuatu" },
  { value: "Vatican City State (Holy See)" },
  { value: "Venezuela" },
  { value: "Vietnam" },
  { value: "Virgin Islands (British)" },
  { value: "Virgin Islands (US)" },
  { value: "Wallis And Futuna Islands" },
  { value: "Western Sahara" },
  { value: "Yemen" },
  { value: "Zambia" },
  { value: "Zimbabwe" },
];

const Courses = [
  { value: "Chiropractor" },
  { value: "Dentist" },
  { value: "Dietitian or Nutritionist" },
  { value: "Optometrist" },
  { value: "Pharmacist" },
  { value: "Physician" },
  { value: "Physician Assistant" },
  { value: "Podiatrist" },
  { value: "Registered Nurse" },
  { value: "Therapist" },
  { value: "Veterinarian" },
  { value: "Health Technologist or Technician" },
  { value: "Other Healthcare Practitioners and Technical Occupation" },
  { value: "Nursing, Psychiatric, or Home Health Aid" },
  { value: "Occupational and Physical Therapist Assistant or Aide" },
  { value: "Other Healthcare Support Occupation" },
  { value: "Chief Executive" },
  { value: "General and Operations Manager" },
  {
    value:
      "Advertising, Marketing, Promotions, Public Relations, and Sales Manager",
  },
  { value: "Operations Specialties Manager (e.g., IT or HR Manager)" },
  { value: "Construction Manager" },
  { value: "Engineering Manager" },
  { value: "Accountant, Auditor" },
  { value: "Business Operations or Financial Specialist" },
  { value: "Business Owner" },
  { value: "Other Business, Executive, Management, Financial Occupation" },
  { value: "Architect, Surveyor, or Cartographer" },
  { value: "Engineer" },
  { value: "Other Architecture and Engineering Occupation" },
  { value: "Postsecondary Teacher (e.g., College Professor)" },
  { value: "Primary, Secondary, or Special Education School Teacher" },
  { value: "Other Teacher or Instructor" },
  { value: "Other Education, Training, and Library Occupation" },
  { value: "Arts, Design, Entertainment, Sports, and Media Occupations" },
  { value: "Computer Specialist, Mathematical Science" },
  {
    value:
      "Counselor, Social Worker, or Other Community and Social Service Specialist",
  },
  { value: "Lawyer, Judge" },
  {
    value:
      "Life Scientist (e.g., Animal, Food, Soil, or Biological Scientist, Zoologist)",
  },
  {
    value:
      "Physical Scientist (e.g., Astronomer, Physicist, Chemist, Hydrologist)",
  },
  { value: "Clergy" },
  { value: "Social Scientist and Related Worker" },
  { value: "Other Professional Occupation" },
  { value: "Supervisor of Administrative Support Workers" },
  { value: "Financial Clerk" },
  { value: "Secretary or Administrative Assistant" },
  { value: "Material Recording, Scheduling, and Dispatching Worker" },
  { value: "Other Office and Administrative Support Occupation" },
  {
    value:
      "Protective Service (e.g., Fire Fighting, Police Officer, Correctional Officer)",
  },
  { value: "Chef or Head Cook" },
  { value: "Cook or Food Preparation Worker" },
  {
    value:
      "Food and Beverage Serving Worker (e.g., Bartender, Waiter, Waitress)",
  },
  { value: "Building and Grounds Cleaning and Maintenance" },
  {
    value:
      "Personal Care and Service (e.g., Hairdresser, Flight Attendant, Concierge)",
  },
  { value: "Sales Supervisor, Retail Sales" },
  { value: "Retail Sales Worker" },
  { value: "Insurance Sales Agent" },
  { value: "Sales Representative" },
  { value: "Real Estate Sales Agent" },
  { value: "Other Services Occupation" },
  {
    value:
      "Construction and Extraction (e.g., Construction Laborer, Electrician)",
  },
  { value: "Farming, Fishing, and Forestry" },
  { value: "Installation, Maintenance, and Repair" },
  { value: "Production Occupations" },
  {
    value:
      "Other Agriculture, Maintenance, Repair, and Skilled Crafts Occupation",
  },
  { value: "Aircraft Pilot or Flight Engineer" },
  {
    value:
      "Motor Vehicle Operator (e.g., Ambulance, Bus, Taxi, or Truck Driver)",
  },
  { value: "Other Transportation Occupation" },
  { value: "Military" },
  { value: "Homemaker" },
  { value: "Other Occupation" },
  { value: "Don't Know" },
  { value: "Not Applicable" },
];

export { options, genders, Zones, Countries, Campuses, Courses };
